import React, {useEffect, useState} from "react";
import {Button, Col, Form, FormLabel, Modal, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import {
  fetchAdvancedTypes,
  fetchBankAccounts, fetchCheques,
  fetchClientPaymentData,
  fetchClients,
  fetchInitialClients,
  fetchPOS,
  fetchSalesGeneralSettings
} from "../../../../_apis/api";
import {useDispatch, useSelector} from "react-redux";
import {
  expandSearch,
  getDefaultOptionByValue,
  getModeByInstallation,
  getNumberByInstallation,
  getOptionsByData,
  getPreNumberByInstallation,
  getSelectedInstallation,
  getSelectedPreNumbers,
  isEmpty,
  removeDuplicateObjects,
} from "../../../../_helpers/commonFunctions";
import "react-datepicker/dist/react-datepicker.css";
import {setSaveClientPayments} from "../../../../_reducers/activitySlice";
import {getLabelByValue, getObjectFromArrayOfObjects,} from "../../../../_helpers/helperFunctions";
import {
  newClientPaymentInitialValue,
  setAutoClientPaymentData,
  setNewClientPayment
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import TextArea from "antd/lib/input/TextArea";
import EditableTable from "../../../primer/Editable-Table";
import {toast} from "react-toastify";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import AccountingBox from "../../../primer/AccountingBox";
import DateBox from "../../../primer/DateBox";
import axios from "axios";
import moment from "moment";
import TipComponent from "../../../primer/TipComponent/TipComponent";
import {useTranslation} from "../../../../hooks/useTranslation";

const ClientPaymentsNew = ({lockPaymentType = false, lockDocumentType = false}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const company = useSelector((state) => state.COMPANY_DATA.company);
  const clientsListData = useSelector((state) => state.CLIENTS_DATA.clients);
  const newClientPayment = useSelector((state) => state.CLIENTS_DATA.newClientPayment);
  const posList = useSelector((state) => state.CASH_DATA.posList);
  const bankAccounts = useSelector((state) => state.CASH_DATA.bankAccounts);
  const chequeList = useSelector((state) => state.CASH_DATA.chequeList);
  const saveClientPayments = useSelector((state) => state.ACTIVITY.saveClientPayments);
  const allDocumentTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
  const salesGeneralSettings = useSelector((state) => state.SALES_SETTINGS.salesGeneralSettings);
  const autoClientPaymentData = useSelector((state) => state.CLIENTS_DATA.autoClientPaymentData);

  const [incrKey, setIncrKey] = useState(0);
  const [showPaymentTypeConfirmation, setShowPaymentTypeConfirmation] = useState(false);
  const [paymentTypeTempData, setPaymentTypeTempData] = useState({});
  const [showErrors, setShowErrors] = useState(false);

  const availableCheques =
      (newClientPayment.paymentTypeType === "cheque" && newClientPayment.client) ?
          chequeList.filter((el) => el.entityId === newClientPayment.client && el.entityType === "client" && !el.used).map((o) => {
            return {
              ...o,
              issueDate: moment(o.issueDate).format("DD/MM/YYYY"),
              expiryDate: moment(o.expiryDate).isValid() ? moment(o.expiryDate).format("DD/MM/YYYY") : "-",
            }
          })
          : [];

  useEffect(() => {
    setIncrKey(incrKey + 1);
  }, [newClientPayment.bankDetails, newClientPayment.posDetails]);

  let selectedClintData = [];

  const initialChequeDetails = [{
    _id: "",
    no: "1",
    id: "1",
    numbering: "",
    amount: 0,
  }]

  const requestData = {
    company: company.id,
    year: company.year.toString(),
  };
  let requestDataF = {
    company: company.id,
    year: company.year.toString(),
    name: ''
  };
  const requestData2 = {
    company: company.id,
    year: company.year.toString(),
    isActive: "active"
  };
  const clientPaymentsDT = getObjectFromArrayOfObjects(
    allDocumentTypes,
    "Client Payments",
    "section"
  );
  const documentTypesOptions = getOptionsByData(
    clientPaymentsDT,
    "_id",
    "name"
  );
  const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
  let selectedDocumentTypeData = [];
  let dtInstallationsOptions = [];

  useEffect(() => {
    dispatch(fetchAdvancedTypes(requestData));
    dispatch(fetchClientPaymentData(requestData));
    dispatch(fetchSalesGeneralSettings(requestData2));
    dispatch(fetchPOS(requestData2));
    dispatch(fetchBankAccounts(requestData2));
    dispatch(fetchCheques(requestData));
    dispatch(fetchInitialClients(requestData));
  }, []);

  useEffect(() => {
    if (autoClientPaymentData) {
      dispatch(setAutoClientPaymentData(null));
      let prepObj = {...newClientPayment};
      if (autoClientPaymentData.documentType) {
        prepObj = handleOnChange({value: autoClientPaymentData.documentType}, "dd", "documentType", prepObj);
      }
      dispatch(setNewClientPayment({...prepObj}));
    }
  }, [autoClientPaymentData]);

  useEffect(() => {
    if (newClientPayment.installation !== undefined && newClientPayment.installation !== ''){
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, newClientPayment.installation);
      setPreNumberGreekOptions(newPreNumbers);
    }
  }, []);

  useEffect(() => { //for template
    if(newClientPayment.installation !== undefined && newClientPayment.installation !== ''){
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, newClientPayment.installation);
      setPreNumberGreekOptions(newPreNumbers);
    }
  }, [newClientPayment.installation]);

  const [returnablePayments, setReturnablePayments] = useState([]);
  useEffect(() => {
    if (newClientPayment.myDataType === "8.5") {
      axios.post(process.env.REACT_APP_API_URL2 + "/client/get-returnable-clientpayments", {company: company.id}, {
        headers: {"Content-Type": "application/json"},
      }).then((res) => {
        if (res.data.status === "200") {
          setReturnablePayments(res.data.data);
        }
      }).catch((err) => {
        console.log(err);
      })
    }
  }, [newClientPayment.myDataType])

  const [defaultForSaleData, setDefaultForSaleData] = useState([]);
  useEffect(() => {
    if(newClientPayment.client && newClientPayment.installation) {
      loadDefaultUnpaidSales();
    }
  }, [newClientPayment.client, newClientPayment.documentType])
  const paymentTypeOptions = getOptionsByData(
    salesGeneralSettings.paymentTypes?.filter((el) => el.type !== "credit"),
    "_id",
    "name"
  );

  let disabledFields = false;
  if (
    newClientPayment.documentType === undefined ||
    newClientPayment.documentType === ""
  ) {
    disabledFields = true;
  } else {
    let dtData = getObjectFromArrayOfObjects(
      clientPaymentsDT,
      newClientPayment.documentType,
      "_id"
    );
    if (dtData.length > 0) {
      selectedDocumentTypeData = dtData["0"];
      dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
      dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
    }
  }
  const handlePaymentTypeConfirmation = () => {
    // Populate Selected Category Data
    let newClientPaymentData = {};
    let type = paymentTypeTempData.type;
    newClientPaymentData.paymentType = paymentTypeTempData.paymentType;
    newClientPaymentData.paymentTypeName = paymentTypeTempData.name;
    newClientPaymentData.paymentTypeType = type;
    if (type === "cash" || type === "iris") {
      newClientPaymentData.posDetails = newClientPaymentInitialValue.posDetails;
      newClientPaymentData.bankDetails = newClientPaymentInitialValue.bankDetails;
    }
    if (type === "pos") {
      newClientPaymentData.amount = "";
      newClientPaymentData.bankDetails = newClientPaymentInitialValue.bankDetails;
    }
    if (type === "bank-account" || type === "web-banking" || type === "bank-account-outside") {
      newClientPaymentData.amount = "";
      newClientPaymentData.posDetails = newClientPaymentInitialValue.posDetails;
    }
    dispatch(setNewClientPayment({...newClientPayment, ...newClientPaymentData}));
    setShowPaymentTypeConfirmation(false);
  };

  const handleOnChange = (e, type = "default", ddname = "", currentState = null) => {
    setShowErrors(true);
    if (!saveClientPayments) dispatch(setSaveClientPayments(true));
    let name;
    let value;
    let salesData = Object.assign({}, currentState ? currentState : newClientPayment);
    let newClientPaymentData = {};
    if (type === "dd") {
      value = e.value;
      name = ddname;
    } else if (type === 'ac') {
      value = e.target.value;
      name = ddname;
    } else if (type === "dp") {
      value = e;
      name = ddname;
    } else if (type === "acdd") {
      if (ddname === "returnPayment") {
        newClientPaymentData.returnPayment = e.row._id;
        newClientPaymentData.returnPaymentLabel = e.row.date + " | " + e.row.documentTypeName + " | " + e.row.number;
        const cloneFields = ["paymentType", "paymentTypeName", "paymentTypeType", "client", "clientName", "vatNumber", "address", "country",
          "phone", "email", "amount", "posDetails", "bankDetails", "chequeDetails", "clientCode", "installation"];
        for (let key of cloneFields) {
          newClientPaymentData[key] = e.row[key];
        }
      } else if (ddname === "chequeSelection") {
        const chequeData = e.row;
        newClientPaymentData["chequeDetails"] = [{
          _id: chequeData._id,
          no: "1",
          id: "1",
          amount: chequeData.amount,
          numbering: chequeData.numbering,
        }]
        newClientPaymentData["amount"] = chequeData.amount;
      } else {
        selectedClintData = []
        e = e.row;
        selectedClintData.push(e)
        value = e._id;
        name = ddname;
      }
    } else if (type === "acdd2") { // forSale
      value = e.row.value;
      name = "forSale";
    } else if (type === "tp") {
      value = e;
      name = ddname;
    } else {
      value = e.target.value;
      name = e.target.name;
    }

    if (name !== "paymentType") {
      newClientPaymentData[name] = value;
    }

    if (name === "documentType") {
      newClientPaymentData[name] = value;
      newClientPaymentData.documentTypeName = getLabelByValue(documentTypesOptions, value, "value");
      let selectedDocumentTypeData = getObjectFromArrayOfObjects(clientPaymentsDT, value, "_id");
      if (selectedDocumentTypeData.length > 0) {
        let selectedDTData = selectedDocumentTypeData["0"];
        let selectedInstallation = getSelectedInstallation(selectedDTData["documentNumbering"]);
        newClientPaymentData.myDataType = selectedDTData.myDataType;
        newClientPaymentData.returnPayment = "";
        newClientPaymentData.returnPaymentLabel = "";
        if (selectedDTData.myDataType === "8.4" || selectedDTData.myDataType === "8.5") {
          newClientPaymentData.date = moment().toDate();
          newClientPaymentData.forSale = "";
          newClientPaymentData.forSaleInputLabel = "";
          newClientPaymentData.openPOS = "";
        }
        if (Object.keys(selectedInstallation).length > 0) {
          newClientPaymentData.installation = selectedInstallation.installationMasterId;
          newClientPaymentData.preNumber = selectedInstallation.preNumber;
          newClientPaymentData.number = selectedInstallation.number + 1;
          newClientPaymentData.installationMode = selectedInstallation.numberingMode;
          newClientPaymentData.numberingMode = selectedInstallation.numberingMode;
        }
        const paymentObjArr = salesGeneralSettings.paymentTypes.filter((el) => el._id === selectedDTData.proposedPaymentType);
        if (paymentObjArr.length > 0) {
          const paymentObj = paymentObjArr[0];
          newClientPaymentData.paymentType = paymentObj._id;
          newClientPaymentData.paymentTypeName = paymentObj.name;
          newClientPaymentData.paymentTypeType = paymentObj.type;
        }
        if (selectedDTData.proposedPosBankAccount !== undefined && selectedDTData.proposedPosBankAccount !== "") {
          if (posList.length > 0 || bankAccounts.length > 0) {
            if (selectedDTData.proposedPaymentTypeType === "pos") {
              const selectedPos = posList.filter(pos => pos._id === selectedDTData.proposedPosBankAccount)[0];
              let selectedPosDetails = {
                _id: selectedPos._id,
                id: "1",
                no: "1",
                name: selectedPos.name,
                registrationNumber: selectedPos.serialNumber,
                amount: 0,
                notes: ""
              }
              newClientPaymentData.posDetails = [];
              newClientPaymentData.posDetails.push(selectedPosDetails);
            } else if ((selectedDTData.proposedPaymentTypeType === "bank-account" || selectedDTData.proposedPaymentTypeType === "web-banking" || selectedDTData.proposedPaymentTypeType === "bank-account-outside") && !lockPaymentType) {
              const selectedBank = bankAccounts.filter(bank => bank._id === selectedDTData.proposedPosBankAccount)[0];
              let selectedBankDetails = {
                _id: selectedBank._id,
                id: "1",
                no: "1",
                name: selectedBank.name,
                accountNumber: selectedBank.iban,
                amount: 0,
                notes: ""
              }
              newClientPaymentData.bankDetails = [];
              newClientPaymentData.bankDetails.push(selectedBankDetails);
            }
          }
        }
      }
      let p = newClientPaymentData.preNumber;
      // This will pre number given in document number table
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData["documentNumbering"], preNumberGreek);
      newPreNumbers = newPreNumbers.flatMap((item) => {
        if (p !== item.value) {
          return []
        } else {
          return item
        }
      });
      setPreNumberGreekOptions(newPreNumbers);
    }
    if (name === "date") {
      newClientPaymentData.date = value;
    }

    if (name === 'installation') {
      newClientPaymentData.installation = value;
      newClientPaymentData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
      newClientPaymentData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
      newClientPaymentData.numberingMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
      newClientPaymentData.number = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId') + 1;
      let p = newClientPaymentData.preNumber;
      // This will pre number given in document number table
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData["documentNumbering"], preNumberGreek);
      newPreNumbers = newPreNumbers.flatMap((item) => {
        if (p !== item.value) {
          return []
        } else {
          return item
        }
      });
      setPreNumberGreekOptions(newPreNumbers);
      newClientPaymentData.forSale = "";
      newClientPaymentData.forSaleInputLabel = "";
      newClientPaymentData.openPOS = "";
    }

    if (name === "client") {
      // populating client values on the sales form
      let selectedClient = getObjectFromArrayOfObjects(clientsListData, value, "_id");
      if (selectedClient.length === 0) {
        selectedClient = [...selectedClintData]
      }
      if (selectedClient.length > 0) {
        let sClient = selectedClient["0"];
        newClientPaymentData.clientName = sClient.name;
        newClientPaymentData.clientCode = sClient.systemCode; // It is the client code
        newClientPaymentData.address = sClient.address;
        newClientPaymentData.vatNumber = sClient.vatNumber;
        newClientPaymentData.doy = sClient.DOY;
        newClientPaymentData.city = sClient.city;
        newClientPaymentData.pc = sClient.postalCode;
        newClientPaymentData.country = sClient.country;
        newClientPaymentData.phone = sClient.phone;
        newClientPaymentData.email = sClient.email.replaceAll("mailto:", "");
        newClientPaymentData.forSale = "";
        newClientPaymentData.forSaleInputLabel = "";
        newClientPaymentData.openPOS = "";
      }
    }

    if (name === "paymentType") {
      let paymentTypesData = getObjectFromArrayOfObjects(salesGeneralSettings.paymentTypes, value, "_id");
      if (paymentTypesData && paymentTypesData.length > 0) {
        // Show warning before change
        if (salesData.paymentType !== "" && salesData.paymentType !== undefined && salesData.paymentTypeType !== paymentTypesData["0"].type) {
          setShowPaymentTypeConfirmation(true);
          let paymentTypeName = getLabelByValue(paymentTypeOptions, value, "value");
          setPaymentTypeTempData({name: paymentTypeName, paymentType: value, type: paymentTypesData["0"].type,});
        } else {
          newClientPaymentData[name] = value;
          newClientPaymentData.paymentTypeName = getLabelByValue(paymentTypeOptions, value, "value");
          newClientPaymentData.paymentTypeType = paymentTypesData["0"].type;
        }
      }
    }

    if (name === "forSale") {
      newClientPaymentData.forSaleInputLabel = e.row.documentTypeName + " " + e.row.number;
      if (e.row?.myDataDestination === "provider" && e.row?.myDataPaymentId === "5") {
        newClientPaymentData.openPOS = "true";
      } else {
        newClientPaymentData.openPOS = "false";
      }
    }

    if (["documentType", "client", "paymentType"].includes(name)) newClientPaymentData.chequeDetails = initialChequeDetails;

    if (currentState) {
      return {...salesData, ...newClientPaymentData};
    } else {
      dispatch(setNewClientPayment({...salesData, ...newClientPaymentData}));
    }
  }

  const clientDropdownColumns = [
    {
      label: t('SalesClientPaymentsNew.dropTable.code'),
      name: "systemCode",
    },
    {
      label: t('SalesClientPaymentsNew.dropTable.name'),
      name: "name",
    },
    {
      label: t('SalesClientPaymentsNew.dropTable.phone'),
      name: "phone",
    },
    {
      label: t('SalesClientPaymentsNew.dropTable.email'),
      name: "email",
    },
  ];

  const posFieldColumns = [
    {
      label: t('SalesClientPaymentsNew.smallTable.name'),
      name: "name",
    },
    {
      label: t('SalesClientPaymentsNew.smallTable.serialNumber'),
      name: "serialNumber",
    },
  ];

  const bankFieldColumns = [
    {
      label: t('SalesClientPaymentsNew.bankTable.accountName'),
      name: "name",
    },
    {
      label: t('SalesClientPaymentsNew.bankTable.bankName'),
      name: "bankName",
    },
    {
      label: t('SalesClientPaymentsNew.bankTable.bankAccountName'),
      name: "iban",
    },
  ];

  const posColumns = [
    {
      name: t('SalesClientPaymentsNew.posTable.posName'),
      field: "name",
      editable: true,
      inputType: {
        config: {
          onChangeSearchCell: (_, keyword, setData) => {
            setData(posList?.filter((el) => expandSearch(keyword).test(el.name)))
          },
          excludeColumns: [],
          columns: posFieldColumns,
          data: posList,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: "Select POS",
        },
        type: "advanced-combobox",
      },
    },
    {
      name: t('SalesClientPaymentsNew.posTable.posRegistrationNumber'),
      field: "registrationNumber",
      editable: false,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesClientPaymentsNew.posTable.amount'),
      field: "amount",
      editable: true,
      inputType: {
        type: "accounting",
        config: {
          suffix: "€",
          maxLength: 10,
        },
      },
    },
    {
      name: t('SalesClientPaymentsNew.posTable.notes'),
      field: "notes",
      editable: true,
      inputType: {
        type: "text",
      },
    },
  ];

  const bankAccountColumns = [
    {
      name: t('SalesClientPaymentsNew.bank2Table.bankAccount'),
      field: "name",
      editable: true,
      inputType: {
        config: {
          onChangeSearchCell: (_, keyword, setData) => {
            setData(bankAccounts?.filter((el) => expandSearch(keyword).test(el.name)))
          },
          excludeColumns: [],
          columns: bankFieldColumns,
          data: bankAccounts,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: "Select Bank",
          disabled: lockPaymentType,
        },
        type: "advanced-combobox",
      },
    },
    {
      name: t('SalesClientPaymentsNew.bank2Table.accountNumber'),
      field: "accountNumber",
      editable: false,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesClientPaymentsNew.bank2Table.amount'),
      field: "amount",
      editable: true,
      inputType: {
        type: "accounting",
        config: {
          suffix: "€",
          maxLength: 10,
        },
      },
    },
    {
      name: t('SalesClientPaymentsNew.bank2Table.notes'),
      field: "notes",
      editable: true,
      inputType: {
        type: "text",
      },
    },
  ];

  const CheckColumns = [
    {
      name: t('SalesClientPaymentsNew.checkTable.startDate'),
      field: "startDate",
      editable: true,
      inputType: {
        type: "datebox",
        allowOtherYears: "true",
      },
    },
    {
      name: t('SalesClientPaymentsNew.checkTable.endDate'),
      field: "endDate",
      editable: true,
      inputType: {
        type: "datebox",
        allowOtherYears: "true",
      },
    },
    {
      name: t('SalesClientPaymentsNew.checkTable.amount'),
      field: "amount",
      editable: true,
      inputType: {
        type: "accounting",
        config: {
          suffix: "€",
          maxLength: 10,
        },
      },
    },
    {
      name: t('SalesClientPaymentsNew.checkTable.notes'),
      field: "notes",
      editable: true,
      inputType: {
        type: "text",
      },
    },
  ];

  const posDetailsActions = {
    insert: () => {},
    update: (data, id) => {
      if (!saveClientPayments) dispatch(setSaveClientPayments(true));

      if (data.name && data.name === "") {
        toast.error("Name is mandatory field.");
      } else {
        let cpPosDetails = newClientPayment.posDetails.slice();
        let foundPos = cpPosDetails.find((item) => item.id === id);
        if (foundPos !== undefined) {
          let rowPosDetail = [];
          // special case update name by name
          if (data.name && data.name !== "") {
            rowPosDetail = getObjectFromArrayOfObjects(posList, data.name, "name");
          }
          // Field auto population on change product
          if (rowPosDetail.length > 0) {
            let rowPosDetailData = rowPosDetail["0"];
            data._id = rowPosDetailData._id;
            data.name = rowPosDetailData.name;
            data.registrationNumber = rowPosDetailData.serialNumber;
          }
          foundPos = { ...foundPos, ...data };
          const updateCpPos = { ...cpPosDetails[id - 1], ...foundPos };
          cpPosDetails[id - 1] = updateCpPos;
          let innerData = {...newClientPayment};
          innerData.amount = updateCpPos.amount
          dispatch(setNewClientPayment({...innerData, posDetails: cpPosDetails}));
        }
      }
    },
    selected: () => {},
    delete: () => {},
  };

  const bankDetailsActions = {
    insert: () => {},
    update: (data, id) => {
      // Set if editing the form
      if (!saveClientPayments) dispatch(setSaveClientPayments(true));

      if (data.name && data.name === "") {
        toast.error("Name is mandatory field.");
      } else {
        let cpBankDetails = newClientPayment.bankDetails.slice();
        let foundBank = cpBankDetails.find((item) => item.id === id);
        if (foundBank !== undefined) {
          let rowBankDetail = [];
          if (data.name && data.name !== "") {
            rowBankDetail = getObjectFromArrayOfObjects(
              bankAccounts,
              data.name,
              "name"
            );
          }
          if (rowBankDetail.length > 0) {
            let rowBankDetailData = rowBankDetail["0"];
            data._id = rowBankDetailData._id;
            data.name = rowBankDetailData.name;
            data.accountNumber = rowBankDetailData.iban;
          }
          foundBank = { ...foundBank, ...data };
          const updateCpBank = { ...cpBankDetails[id - 1], ...foundBank };
          cpBankDetails[id - 1] = updateCpBank;
          let innerData = {...newClientPayment};
          innerData.amount = updateCpBank.amount
          dispatch(setNewClientPayment({...innerData, bankDetails: cpBankDetails}));
        }
      }
    },
    selected: () => {},
    delete: () => {},
  };

  const selectedDocumentType = getDefaultOptionByValue(
    documentTypesOptions,
    newClientPayment.documentType,
    "value",
    "label",
    "value"
  );
  const onChangeSearch = (keyword,setData) => {
    requestDataF.name = keyword
    if(keyword.length >= 2) {
      dispatch(fetchClients(requestDataF,setData))
    }
  }
  const loadUnpaidSales = (keyword, setData) => {
    axios.get(process.env.REACT_APP_API_URL2 + `/client/get-unpaid-list`, {
      params: {
        company: company.id,
        documentId: newClientPayment.documentType,
        clientId: newClientPayment.client,
        installation: newClientPayment.installation,
        keyword: keyword
      }}).then(res => {
        if (res.data && res.data.data && res.data.status === '200') {
          let tArr = [];
          res.data.data.forEach((sale) => {
            tArr.push({
              number: sale.number.replace("noprefix", ""),
              totalAmount: sale.totalAmount,
              paymentRemainder: sale.paymentRemainder,
              documentTypeName: sale.documentTypeName,
              date: moment(sale.date).format("DD-MM-YYYY HH:mm"),
              value: String(sale._id),
              myDataDestination: sale?.myDataDestination,
              myDataPaymentId: sale?.myDataPaymentId
            })
          })
          setData(tArr);
        }
      }).catch((err) => {
        console.log(err)
      })
  }
  const loadDefaultUnpaidSales = () => {
    axios.get(process.env.REACT_APP_API_URL2 + `/client/get-unpaid-list`, {
      params: {
        company: company.id,
        documentId: newClientPayment.documentType,
        clientId: newClientPayment.client,
        installation: newClientPayment.installation,
      }}).then(res => {
        if (res.data && res.data.data && res.data.status === '200') {
          let tArr = [];
          res.data.data.forEach((sale) => {
            tArr.push({
              number: sale.number.replace("noprefix", ""),
              totalAmount: sale.totalAmount,
              paymentRemainder: sale.paymentRemainder,
              documentTypeName: sale.documentTypeName,
              date: moment(sale.date).format("DD-MM-YYYY HH:mm"),
              value: String(sale._id),
              myDataDestination: sale?.myDataDestination,
              myDataPaymentId: sale?.myDataPaymentId
            })
          })
          setDefaultForSaleData(tArr);
        }
      }).catch((err) => {
        console.log(err);
      })
  }
  const onChangeSearchUnpaidSales = (keyword, setData) => {
    loadUnpaidSales(keyword, setData);
  }
  const onChangeSearchReturnablePayments = (keyword, setData) => {
    axios.post(process.env.REACT_APP_API_URL2 + "/client/get-returnable-clientpayments", {keyword: keyword, company: company.id}, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        setData(res.data.data);
      }
    }).catch((err) => {
      console.log(err);
    })
  }
  const clearForSale = () => {
    dispatch(setNewClientPayment({...newClientPayment, forSale: "", forSaleInputLabel: ""}));
  }
  const clearReturnPayment = () => {
    dispatch(setNewClientPayment({...newClientPayment, returnPayment: "", returnPaymentLabel: ""}));
  }
  const selectDocumentInstallation = getDefaultOptionByValue(dtInstallationsOptions, newClientPayment.installation, "value", "label", "value");
  const selectedPaymentType = getDefaultOptionByValue(paymentTypeOptions, newClientPayment.paymentType, "value", "label", "value");

  const isInvulnerable  = String(newClientPayment?.returnPayment).length === 24;

  const isTipable = newClientPayment.myDataType === "8.4"
      || (posList.find((el) => el._id === newClientPayment.posDetails[0]._id)?.isETameiaki === "active"
          && !isEmpty(newClientPayment.forSale) && newClientPayment?.openPOS === "true");

  return (
    <div className="new-sales">
      <Form
        className="client-form product-form position-relative"
        autoComplete="off"
      >
        {disabledFields && (
          <div className="overlay_w">{t('SalesClientPaymentsNew.message')}</div>
        )}
        <Row className="border-bottom mb-3">
          <Col sm={12} md={3} className="showWithOverlay">
            <Dropdown
              label={t('SalesClientPaymentsNew.documentTypes')}
              key={selectedDocumentType.value}
              defaultValue={selectedDocumentType}
              required={true}
              name="documentType"
              disabled={isInvulnerable || lockDocumentType}
              options={documentTypesOptions}
              onChange={(e) => handleOnChange(e, "dd", "documentType")}
            />
          </Col>
          {(newClientPayment?.myDataType === "8.5") ? (
              <React.Fragment>
                <Col sm={12} md={5}>
                  <AdvancedCombobox
                      className="w-100 ac-select-dropdown"
                      label={"Συσχετιζόμενη Είσπραξη"}
                      placeholder={"Εισάγετε συσχετιζόμενη είσπραξη"}
                      defaultValue={newClientPayment.returnPaymentLabel}
                      data={returnablePayments}
                      onChange={(e) => handleOnChange(e, "acdd", "returnPayment")}
                      excludeColumns={[]}
                      columns={[
                        {label: "Ημερομηνία", name: "date"},
                        {label: "Τύπος Παραστατικού", name: "documentTypeName"},
                        {label: "Αρίθμηση", name: "number"},
                        {label: "Ποσό", name: "amount"},
                      ]}
                      required={newClientPayment?.myDataType === "8.5"}
                      deleteEnable={false}
                      searchTableEnable={false}
                      showTableOptionOnSelect={true}
                      key={Math.random()}
                      disabled={isInvulnerable}
                      onChangeSearch={onChangeSearchReturnablePayments}
                  />
                </Col>
                <Col md={1}>
                  {String(newClientPayment?.returnPayment).length === 24 &&
                      <button style={{position: "absolute", bottom: "16px"}} className="btn btn-sm" title="Καθαρισμός συσχετιζόμενης είσπραξης" onClick={() => clearReturnPayment()}>
                        <i className="fas fa-xmark"></i></button>
                  }
                </Col>
              </React.Fragment>
          ) : (
              <Col md={6}></Col>
          )}
        </Row>
        <Row className={"mb-3"}>
          <Col sm="12" md="3">
            <DateBox
                classes="w-100"
                label={t('SalesClientPaymentsNew.date')}
                name="date"
                disabled={isInvulnerable || ["8.4", "8.5"].includes(newClientPayment?.myDataType)}
                selected={moment(newClientPayment.date).isValid() ? new Date(newClientPayment.date) : null}
                onChange={(e) => handleOnChange(e, 'dp', 'date')}
            />
            {isEmpty(newClientPayment.date) && <div className={"text-danger"}>Απαιτείται Ημερομηνία.</div> }
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3} className="mb-2">
            <div className="mb-3">
              <Dropdown
                label={t('SalesClientPaymentsNew.installation.installation')}
                options={dtInstallationsOptions}
                value={Object.keys(selectDocumentInstallation).length !== 0 ? selectDocumentInstallation : ''}
                enabledValue={true}
                required={true}
                name="installation"
                classes="w-100"
                disabled={isInvulnerable}
                onChange={(e) => handleOnChange(e, "dd", "installation")}
              />
              {showErrors &&
                newClientPayment.installation === "" && (
                  <div className="text-danger">{t('SalesClientPaymentsNew.installation.required')}</div>
                )}
            </div>
          </Col>
          <Col sm="12" md="3">
            <div className="mb-3">
              <Dropdown
                label={t('SalesClientPaymentsNew.preNumber')}
                name="preNumber"
                key={Math.random()}
                defaultValue={getDefaultOptionByValue(
                  preNumberGreekOptions,
                  newClientPayment.preNumber,
                  "value",
                  "label",
                  "value"
                )}
                options={preNumberGreekOptions}
                disabled={newClientPayment.numberingMode === "manual"}
                onChange={(e) => handleOnChange(e, "dd", "preNumber")}
              />
            </div>
          </Col>
          <Col sm="12" md="3">
            <Input
              className="mb-3 w-100"
              label={t('SalesClientPaymentsNew.number.number')}
              name="number"
              value={newClientPayment.number}
              placeholder={t('SalesClientPaymentsNew.number.placeholder')}
              onChange={(e) => handleOnChange(e)}
              disabled={newClientPayment.numberingMode !== "manual"}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3} className="mb-2">
            <Dropdown
              label={t('SalesClientPaymentsNew.paymentType')}
              options={paymentTypeOptions}
              value={Object.keys(selectedPaymentType).length !== 0 ? selectedPaymentType : ''}
              enabledValue={true}
              name="paymentType"
              disabled={newClientPayment?.myDataType === "8.4" || newClientPayment?.myDataType === "8.5" || isInvulnerable || lockPaymentType}
              searchEnable={true}
              onChange={(e) => handleOnChange(e, "dd", "paymentType")}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3} className="mb-2">
            <AdvancedCombobox
              ACName="Client Payment Client" // do not change name
              className="w-100 ac-select-dropdown"
              defaultValue={newClientPayment.clientName}
              label={t('SalesClientPaymentsNew.client.client')}
              data={clientsListData}
              onChange={(e) => handleOnChange(e, "acdd", "client")}
              onChangeSearch = {onChangeSearch}
              excludeColumns={[]}
              columns={clientDropdownColumns}
              key={newClientPayment.client}
              deleteEnable={false}
              searchTableEnable={false}
              showTableOptionOnSelect={true}
              placeholder={t('SalesClientPaymentsNew.client.placeholder')}
              required={true}
              showInsertAddButton={true}
              hideSaveButton={true}
              hideInsertNewRow={true}
              disabled={isInvulnerable}
            />
            {showErrors && newClientPayment.client === "" && (
              <div className="text-danger">{t('SalesClientPaymentsNew.client.required')}</div>
            )}
          </Col>
          <Col sm="12" md="3">
            <div className="mb-3">
              <Input
                className="w-100"
                label={t('SalesClientPaymentsNew.vatNumber')}
                name="vat"
                value={newClientPayment.vatNumber}
                onChange={(e) => handleOnChange(e)}
                disabled={true}
                readonly
              />
            </div>
          </Col>
          <Col sm="12" md="3">
            <div className="d-flex">
              <Input
                label={t('SalesClientPaymentsNew.address')}
                className="w-100"
                name="address"
                value={newClientPayment.address}
                onChange={(e) => handleOnChange(e)}
                disabled={true}
                readonly
              />
            </div>
          </Col>
          <Col sm="12" md="3">
            <div className="d-flex">
              <Input
                label={t('SalesClientPaymentsNew.country')}
                className="w-100"
                name="country"
                value={newClientPayment.country}
                onChange={(e) => handleOnChange(e)}
                disabled={true}
                readonly
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md="3">
            <div className="d-flex">
              <Input
                label={t('SalesClientPaymentsNew.phone')}
                className="w-100"
                name="phone"
                value={newClientPayment.phone}
                onChange={(e) => handleOnChange(e)}
                disabled={true}
                readonly
              />
            </div>
          </Col>
          <Col sm="12" md="3">
            <div className="d-flex">
              <Input
                label={t('SalesClientPaymentsNew.email')}
                className="w-100"
                name="email"
                value={newClientPayment.email}
                onChange={(e) => handleOnChange(e)}
                disabled={true}
                readonly
              />
            </div>
          </Col>
          {(newClientPayment?.myDataType !== "8.4" && newClientPayment.myDataType !== "8.5") && (
              <React.Fragment>
                <Col sm="12" md="3">
                  <AdvancedCombobox
                      className="w-100 ac-select-dropdown"
                      label={"Αφορά την πώληση"}
                      placeholder={"Προσθέστε πώληση"}
                      defaultValue={newClientPayment.forSaleInputLabel}
                      data={defaultForSaleData}
                      onChange={(e) => handleOnChange(e, "acdd2")}
                      excludeColumns={[]}
                      columns={[
                        {label: "Ημερομηνία", name: "date"},
                        {label: "Τύπος Παραστατικού", name: "documentTypeName"},
                        {label: "Αρίθμηση", name: "number"},
                        {label: "Πληρωτέο Ποσό", name: "totalAmount"},
                        {label: "Υπολ. Ποσό", name: "paymentRemainder"},
                      ]}
                      deleteEnable={false}
                      searchTableEnable={false}
                      showTableOptionOnSelect={true}
                      key={Math.random()}
                      disabled={!newClientPayment.installation || !newClientPayment.client || isInvulnerable || String(newClientPayment.forSale).length === 24}
                      onChangeSearch={onChangeSearchUnpaidSales}
                  />
                </Col>
                <Col sm="12" md="3">
                  {String(newClientPayment.forSale).length === 24 &&
                      <button style={{position: "absolute", bottom: "13px"}} className="btn btn-sm" title="Καθαρισμός επιλεγμένης πώλησης" onClick={() => clearForSale()}><i className="fas fa-xmark"></i></button>
                  }
                </Col>
              </React.Fragment>
          )}
        </Row>
        <br />
        <Row>
          <Col md={12}>
            <Input
              label={t('SalesClientPaymentsNew.reason')}
              className="w-100 mb-3"
              name="reason"
              value={newClientPayment.reason}
              onChange={(e) => handleOnChange(e)}
            />
          </Col>
        </Row>

        {(newClientPayment.paymentTypeType === "cash" || newClientPayment.paymentTypeType === "iris") && (
          <Row>
            <Col sm="12" md="4">
              <div className="mb-3">
                <FormLabel className="" htmlFor="amount">{t('SalesClientPaymentsNew.paymentAmount.paymentAmount')}</FormLabel>
                <AccountingBox
                    name="amount"
                    label="Amount"
                    placeholder={t('SalesClientPaymentsNew.paymentAmount.placeholder')}
                    defaultValue={newClientPayment.amount}
                    key={newClientPayment.amount}
                    onBlur={(e) => handleOnChange(e, 'ac', 'amount')}
                    disabled={isInvulnerable}
                />
              </div>
            </Col>
          </Row>
        )}

        <Row style={{pointerEvents: isInvulnerable ? "none" : ""}}>
        {(newClientPayment.paymentTypeType === "bank-account" || newClientPayment.paymentTypeType === "web-banking" || newClientPayment.paymentTypeType === "bank-account-outside") && (
          <div className="bank-data">
            <div className="text-muted mb-2">
              <i>{t('SalesClientPaymentsNew.bankAccountData')}</i>
            </div>
            <EditableTable
              reqName="bank"
              key={"Client Payment Bank Account Data Table" + incrKey}
              tableName="Client Payment Bank Account Data Table" // do not change name
              allowToggleColumns={true}
              allowActions={true}
              actionButtons={{
                print: false, delete: false, export: false, edit: false
              }}
              allowInsertRow={false}
              allowPagination={false}
              allowBulkDelete={false}
              allowSorting={false}
              allowSelectionCheckbox={false}
              columns={bankAccountColumns}
              allowPrintResults={false}
              enableNewRowCheckbox={true}
              onUpdate={bankDetailsActions}
              data={newClientPayment.bankDetails}
            />
          </div>
        )}

        {newClientPayment.paymentTypeType === "pos" && (
          <div className="pos-data">
            <div className="text-muted mb-2">
              <i>{t('SalesClientPaymentsNew.posData')}</i>
            </div>
            <EditableTable
              reqName="pos"
              key={"Client Payment POS Data Table" + incrKey}
              tableName="Client Payment POS Data Table" // do not change name
              allowToggleColumns={true}
              allowActions={true}
              actionButtons={{
                print: false, delete: false, export: false, edit: false
              }}
              allowInsertRow={false}
              allowPagination={false}
              allowBulkDelete={false}
              allowSorting={false}
              allowSelectionCheckbox={false}
              columns={posColumns}
              enableNewRowCheckbox={true}
              allowPrintResults={false}
              onUpdate={posDetailsActions}
              data={newClientPayment.posDetails}
            />
          </div>
        )}
          {newClientPayment.paymentTypeType === "cheque" && (
              <div>
                <Row>
                  <Col md={9} className={"mb-3"}>
                    <AdvancedCombobox
                        name="chequeSelection"
                        className="w-100 ac-select-dropdown"
                        defaultValue={newClientPayment.chequeDetails[0].numbering}
                        label={"Συσχετιζόμενη επιταγή"}
                        data={availableCheques}
                        key={newClientPayment.chequeDetails[0]._id}
                        onChange={(e) => handleOnChange(e, "acdd", "chequeSelection")}
                        resetFilter={() => dispatch(setNewClientPayment({...newClientPayment, chequeDetails: initialChequeDetails}))}
                        excludeColumns={[]}
                        columns={[
                            {label: "Αριθμός Επιταγής", name: "numbering"},
                            {label: "Ημερομηνία Έκδοσης", name: "issueDate"},
                            {label: "Ημερομηνία Λήξης", name: "expiryDate"},
                            {label: "Ποσό", name: "amount"},
                        ]}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        placeholder={"Επιλέξτε επιταγή"}
                        required={true}
                        showInsertAddButton={true}
                        hideSaveButton={true}
                        hideInsertNewRow={true}
                        inputFieldClasses="form-control"
                    />
                  </Col>
                  {newClientPayment.chequeDetails[0]._id && (
                      <Col md={3}>
                        <label>Ποσό (€)</label>
                        <AccountingBox
                            name={"amount"}
                            key={newClientPayment.chequeDetails[0].amount}
                            defaultValue={newClientPayment.chequeDetails[0].amount}
                            disabled={true}
                        />
                      </Col>
                  )}
                </Row>
              </div>
          )}
        </Row>
        <Row className={"mb-2"}>
          <Col md={isTipable ? 9 : 12}>
            <div className="text-muted mb-2">
              <i>{t('SalesClientPaymentsNew.paymentNotes')}</i>
            </div>
            <TextArea
                rows="4"
                className="form-control"
                placeholder={t('SalesClientPaymentsNew.addNotes')}
                limit="1000"
                name="paymentNotes"
                value={newClientPayment.paymentNotes}
                onChange={(e) => handleOnChange(e)}
            />
          </Col>
          {(isTipable) && (
              <Col md={3}>
                <span>Φιλοδώρημα</span>
                <TipComponent
                    value={newClientPayment.tipAmount}
                    onChange={(amount) => dispatch(setNewClientPayment({
                      ...newClientPayment,
                      tipAmount: amount
                    }))}
                    paymentAmount={newClientPayment.amount}
                />
              </Col>
          )}
        </Row>
      </Form>

      {/* Confirm Category Change */}
      <Modal backdrop={"static"} className="themeModal" show={showPaymentTypeConfirmation}>
        <Modal.Header closeButton>
          <Modal.Title>{t('SalesClientPaymentsNew.warning')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('SalesClientPaymentsNew.message2')}
        </Modal.Body>
        <Modal.Footer>
          <Button
              variant="outline-primary"
              onClick={() => setShowPaymentTypeConfirmation(false)}
          >
            {t('SalesClientPaymentsNew.no')}
          </Button>
          <Button
            variant="primary"
            onClick={() => handlePaymentTypeConfirmation()}
          >
            {t('SalesClientPaymentsNew.yes')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ClientPaymentsNew;
